// extracted by mini-css-extract-plugin
export default {"headerWrapper":"FAQ_headerWrapper__UpOPX","accordionItem":"FAQ_accordionItem__VuhGY","accordionHeader":"FAQ_accordionHeader__LHZ82","collapsed":"FAQ_collapsed__fL5xm"};